import React, { memo, useRef, useState } from 'react';
import { Badge, Button } from 'react-bootstrap';
import { openNewTab, reactHtmlParser } from '../../../common/common';
import LazyImage from '../../CustomLibraries/LazyImage';
import Card from '../components/Card';
import FormQuestionModal from '../../FormQuestionModal';
import { toast } from 'react-toastify';
import axiosInstance from '../../../Store/helper/axiosInstance';

const EventCta = ({
  ctaId = '',
  ctaType = 'event',
  className = '',
  type = '',
  onClick,
  title = '',
  description = '',
  image = '',
  subTitle = '',
  labelObj = {
    isPresent: true,
    position: 'right',
    text: '',
    icon: 'flaticon-video-camera'
  },
  primaryButtonText = '',
  secondaryButtonText = '',
  primaryButtonAction = '',
  secondaryButtonAction = '',
  primaryButtonUrl = '',
  secondaryButtonUrl = '',
  clickCallback,
  form = []
}) => {
  const [show, setShow] = useState(false);
  const onHide = () => setShow(false);
  // for sample type cta extraClass d-flex align-items-center justify-content-center
  // for sample type cta className mw-100 mh-100

  const onPrimaryButtonClick = () => {
    clickCallback && clickCallback(ctaId);
    if (primaryButtonAction?.toLowerCase() == 'new_page') {
      openNewTab(primaryButtonUrl, () => {
        window.location.href = primaryButtonUrl;
      });
    } else if (primaryButtonAction?.toLowerCase() == 'same_page') {
      window.location.href = primaryButtonUrl;
    } else if (primaryButtonAction?.toLowerCase() == 'form') {
      setShow(true);
    }
  };

  const onSecondaryButtonClick = () => {
    clickCallback && clickCallback(ctaId);
    if (secondaryButtonAction?.toLowerCase() == 'new_page') {
      openNewTab(secondaryButtonUrl, () => {
        window.location.href = secondaryButtonUrl;
      });
    } else if (secondaryButtonAction?.toLowerCase() == 'same_page') {
      window.location.href = secondaryButtonUrl;
    } else if (secondaryButtonAction?.toLowerCase() == 'form') {
      setShow(true);
    }
  };
  const postForm = async (userInput) => {
    console.log('user has clicked submit button');
    if (form.some((_q) => _q.is_mandatory == 1 && !userInput[_q.field_name])) {
      toast.error('Please fill all mandatory fields');
      return;
    }
    let response = await axiosInstance.post('cta/cta_submitted_forms', {
      cta_id: ctaId,
      cta_type: ctaType,
      submitted_form_json: userInput
    });
    console.log('response:', response);
    if (response.status == 200) {
      toast.success('Your Response submitted successfully');
      onHide();
    }
  };
  return (
    <>
      <Card className={`clr_v3_card--eventCta ${className ?? ''}`} type={type}>
        <Card.Body>
          <div
            className={`d-flex gap-4 ${type === 'small' ? 'flex-row align-items-center' : 'flex-column'
              }`}
          >
            {/* flex-row */}
            <Card.Image className="cursorPointer">
              {labelObj.isPresent && (
                <div className="position-absolute top-0 right-0 w-100 d-flex z-1 p-3">
                  <Badge
                    bg="white"
                    className="fs-4 px-4 py-3 fw-medium d-flex align-items-center gap-3 justify-content-center ms-auto text-primary"
                  >
                    <i className={'fs-3 text-primary ' + labelObj?.icon}></i>
                    {labelObj.text}
                  </Badge>
                </div>
              )}
              <LazyImage
                src={image}
                alt="banner"
                fallback_image={
                  'https://previews.123rf.com/images/varijanta/varijanta1604/varijanta160400086/55848266-modern-thin-line-design-concept-for-healthcare-website-banner-vector-illustration-concept-for-health.jpg'
                }
                className={'object-fit-cover w-100 h-100'}
              />
            </Card.Image>

            <div className="d-flex flex-column">
              {title && <Card.Title className="hover-opacity mt-1">{title}</Card.Title>}
              {subTitle && (
                <h2 className={'fs-4 text-black line-clamp-2 fw-semibold mt-2'}>{subTitle}</h2>
              )}

              {description && (
                <Card.Description showFullText className="mt-2">
                  {reactHtmlParser(description)}
                </Card.Description>
              )}

              <div className="mt-4 d-flex gap-3 flex-wrap">
                {secondaryButtonText && (
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className={`flex-grow-1 text-nowrap fs-4 gap-2 d-flex justify-content-center align-items-center`}
                    onClick={onSecondaryButtonClick}
                  >
                    {secondaryButtonText}
                  </Button>
                )}
                {primaryButtonText && (
                  <Button
                    size="sm"
                    className={`flex-grow-1 text-nowrap fs-4 gap-2 d-flex justify-content-center align-items-center`}
                    onClick={onPrimaryButtonClick}
                  >
                    {primaryButtonText}
                    <i className="flaticon-next"></i>
                  </Button>
                )}
              </div>
            </div>
          </div>
        </Card.Body>
        {/* card comments end */}
        {/* <CommentsAtEnd /> */}
      </Card>
      {form.length > 0 && (primaryButtonAction === 'form' || secondaryButtonAction === 'form') && (
        <FormQuestionModal show={show} onHide={onHide} submitClick={postForm} form={form} />
      )}
    </>
  );
};

export default memo(EventCta);
